import { Paper, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import type { PointsStatsResponse } from '@fields/data-access';

import classes from './sampling-stats-card.module.css';

interface SamplingStatsCardProps {
  stats: PointsStatsResponse;
}

interface StatItemProps {
  label: string;
  value: number;
  color: string;
}

function StatItem({ label, value, color }: StatItemProps) {
  return (
    <Paper className={classes.stat} p="md" radius="md" withBorder>
      <Stack align="center" gap="xs">
        <Text className={classes.value} c={color} fw={700} size="xl">
          {value}
        </Text>
        <Text c="dimmed" size="sm" ta="center">
          {label}
        </Text>
      </Stack>
    </Paper>
  );
}

export function SamplingStatsCard({ stats }: SamplingStatsCardProps) {
  const { t } = useTranslation();

  return (
    <Stack gap="md" p="md">
      <Title order={3}>{t('dashboard.samplingTitle')}</Title>
      <SimpleGrid cols={1} spacing="sm">
        <StatItem
          color="dark"
          label={t('dashboard.samplingTotal')}
          value={stats.total}
        />
        <StatItem
          color="green"
          label={t('dashboard.samplingFinished')}
          value={stats.sampled}
        />
        <StatItem
          color="orange"
          label={t('dashboard.samplingRemaining')}
          value={stats.remaining}
        />
      </SimpleGrid>
    </Stack>
  );
}

export default SamplingStatsCard;
